import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import styles from './style.module.scss';
import Headline from '../Headline';
import { Container, Row, Col } from 'reactstrap';
import cn from 'classnames';
import { withThemeVariant } from '../../provider/ThemeProvider/index';
/**
 * A generic section component providing basic section alignment and styling
 *
 * @param	{string}			backgroundClass	An additional background class (E.g. Image styles)
 * @param	{string}			backgroundColor	A css conform hex/rgb/rgba color code
 * @param	{string}			className       Additional class selector
 * @param {content}			headline				The sections headline
 * @param	{content}			subheader				The sections subheader
 * @param	{boolean}			noPadding				Wether or not to render with padding
 * @param	{boolean}			noMargin				Wether or not to render with margin
 * @param	{boolean}			center					Wether or not to center the content
 * @param	{Children}    children				The sections content
 * @param	{boolean} 	  row				      Wether or not to provide a row wrapper (// TODO: Refactor)
 * @param {string}      dividerStyle    The display style of the sections divider
 **/

export var Section = function Section(_ref) {
  var _cn, _cn2;

  var children = _ref.children,
      _ref$backgroundClass = _ref.backgroundClass,
      backgroundClass = _ref$backgroundClass === void 0 ? false : _ref$backgroundClass,
      className = _ref.className,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'default' : _ref$backgroundColor,
      _ref$headline = _ref.headline,
      headline = _ref$headline === void 0 ? false : _ref$headline,
      _ref$subheader = _ref.subheader,
      subheader = _ref$subheader === void 0 ? false : _ref$subheader,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$noPaddingBottom = _ref.noPaddingBottom,
      noPaddingBottom = _ref$noPaddingBottom === void 0 ? false : _ref$noPaddingBottom,
      _ref$noPaddingTop = _ref.noPaddingTop,
      noPaddingTop = _ref$noPaddingTop === void 0 ? false : _ref$noPaddingTop,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? false : _ref$center,
      _ref$contentPadding = _ref.contentPadding,
      contentPadding = _ref$contentPadding === void 0 ? false : _ref$contentPadding,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? true : _ref$row,
      anchor = _ref.anchor,
      _ref$globalThemeVaria = _ref.globalThemeVariant,
      globalThemeVariant = _ref$globalThemeVaria === void 0 ? 'pc' : _ref$globalThemeVaria,
      _ref$dividerStyle = _ref.dividerStyle,
      dividerStyle = _ref$dividerStyle === void 0 ? 'none' : _ref$dividerStyle,
      _ref$smallPaddingBott = _ref.smallPaddingBottom,
      smallPaddingBottom = _ref$smallPaddingBott === void 0 ? false : _ref$smallPaddingBott,
      _ref$globalThemeSubVa = _ref.globalThemeSubVariant,
      globalThemeSubVariant = _ref$globalThemeSubVa === void 0 ? '' : _ref$globalThemeSubVa;
  return React.createElement("section", {
    className: cn((_cn = {}, _defineProperty(_cn, styles.section, true), _defineProperty(_cn, styles.noPadding, noPadding), _defineProperty(_cn, styles.noPaddingTop, noPaddingTop), _defineProperty(_cn, styles.noPaddingBottom, noPaddingBottom), _defineProperty(_cn, styles.smallPaddingBottom, smallPaddingBottom), _defineProperty(_cn, styles.news, globalThemeSubVariant === 'news'), _defineProperty(_cn, className, className), _cn), styles[globalThemeVariant]),
    style: {
      marginTop: noMargin && '0'
    }
  }, anchor && React.createElement("a", Object.assign({
    className: styles.pseudoAnchor
  }, {
    id: anchor
  }), ' '), globalThemeVariant === 'bc' && dividerStyle !== 'none' && React.createElement("div", {
    className: cn(styles.dividerTop, styles[dividerStyle])
  }), React.createElement("div", {
    className: cn(styles.background, [styles[backgroundColor]], (_cn2 = {}, _defineProperty(_cn2, backgroundClass, backgroundClass), _defineProperty(_cn2, styles.hasHeader, headline || subheader), _cn2))
  }, React.createElement(Container, null, (headline || subheader) && React.createElement(Row, {
    className: styles.header
  }, React.createElement(Col, null, headline && React.createElement(Headline, {
    size: 2,
    noMargin: true,
    center: globalThemeVariant === 'pc',
    color: backgroundColor === 'dark' ? 'white' : null
  }, headline), subheader && React.createElement(Headline, {
    size: 3,
    noMargin: true,
    center: true,
    color: backgroundColor === 'dark' ? 'white' : null
  }, subheader))), React.createElement("div", {
    className: contentPadding ? styles.contentPadding : styles.content,
    style: {
      textAlign: center ? 'center' : 'left'
    }
  }, row ? React.createElement(Row, {
    className: "justify-content-md-center"
  }, children) : children))), globalThemeVariant === 'bc' && dividerStyle !== 'none' && React.createElement("div", {
    className: cn(styles.dividerBottom, styles[dividerStyle])
  }));
};
export default withThemeVariant(Section);